import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Eye, EyeOff } from 'lucide-react';
import { authenticateAdmin } from '../utils/auth';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const admin = localStorage.getItem('admin');
    if (admin) {
      navigate('/');
    }
  }, [navigate]);

  const handleLogin = async () => {
    try {
      setError(''); // Clear previous errors
      
      if (!username || !password) {
        setError('Please enter both username and password');
        return;
      }

      console.log('Attempting login...'); // Debug log
      const adminData = await authenticateAdmin(username, password);

      if (!adminData) {
        setError('Invalid username or password');
        return;
      }

      // Store admin session
      localStorage.setItem('admin', JSON.stringify(adminData));
      navigate('/');

    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to login. Please try again.');
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#f6faff] dark:bg-[#181825] px-4 transition-colors">
      <div className="w-full max-w-md bg-white/90 dark:bg-[#232634]/90 backdrop-blur-md rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold mb-6 text-center text-[#232634] dark:text-white">Login</h2>
        {error && <p className="text-red-500 dark:text-red-400 mb-4">{error}</p>}
        <div className="space-y-4">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full bg-gray-100 dark:bg-gray-800 text-[#232634] dark:text-white placeholder:text-gray-400 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          />
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-gray-100 dark:bg-gray-800 text-[#232634] dark:text-white placeholder:text-gray-400 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-[#232634] dark:hover:text-white transition-colors"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
          <button
            onClick={handleLogin}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-semibold"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
}
